<template>
  <div class="pageMyReservationTempForm">
    <el-row :gutter="24">
      <el-col :span="12">
        <h2>{{ $t("pages.wording.reserve") }}</h2>
        <!--我的預約單-->
      </el-col>
      <el-col :span="12">
        <div v-if="parent" class="buttons c-form">
          <el-button class="blue-button button-right" @click="back" type="primary">{{
            $t("pages.button.back")
          }}</el-button
          ><!--關閉-->
        </div>
      </el-col>
    </el-row>

    <el-form :rules="rules" ref="ruleForm" :model="ruleForm" label-width="120px">
      <el-collapse v-model="activeShowBlock">
        <el-collapse-item class="collapsecontent" name="basic">
          <template slot="title">
            <h3>{{ $t("pages.wording.basisInfo") }}</h3>
            <!--基本資訊-->
          </template>
          <div class="boxContain c-form">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveNo')"
                  ><!--單號-->
                  <el-input
                    :disabled="true"
                    v-model="ruleForm.reserveNo"
                    :placeholder="$t('pages.wording.placeholderAutoGenerate')"
                  ></el-input
                  ><!--自動產生-->
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.deltaContactName')" prop="deltaContactName"
                  ><!--接洽人姓名-->
                  <QueryEmpUser :model.sync="ruleForm.deltaContactDisplayName" @change="onChangeUser" keyName="code" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.applyDate')" prop="applyDate"
                  ><!--填單日期-->
                  <el-input :disabled="true" v-model="ruleForm.applyDate"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.deltaContactNumber')" prop="deltaContactNumber"
                  ><!--接洽人電話-->
                  <el-input
                    v-model="ruleForm.deltaContactNumber"
                    :placeholder="$t('pages.wording.placeholderInput')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.applicatorName')" prop="applicatorName"
                  ><!--填單人-->
                  <el-input :disabled="true" v-model="ruleForm.applicatorName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.deltaContactMail')" prop="deltaContactMail"
                  ><!--接洽人Mail-->
                  <el-input
                    v-model="ruleForm.deltaContactMail"
                    :placeholder="$t('pages.wording.placeholderInput')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!--boxContain c-form-->
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="reserve">
          <template slot="title">
            <div class="titleBtn">
              <h3>{{ $t("pages.wording.containForm") }}</h3>
              <!--填單內容-->
              <el-button
                v-if="ruleForm.reserveType == 'ERP_ONE'"
                class="blue-button"
                @click="dialog.vendorContact = true"
                type="primary"
                >{{ $t("pages.wording.editVendorContactData") }}</el-button
              ><!--取消-->
            </div>
          </template>
          <div class="boxContain c-form">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveFactory')" prop="reserveFactory"
                  ><!--抵達廠別-->
                  <el-select
                    v-model="ruleForm.reserveFactory"
                    :placeholder="$t('pages.wording.placeholderSelect')"
                    @change="selectedReserveFactory"
                  >
                    <el-option
                      v-for="item in base.vendorFactoryById"
                      :label="item"
                      :value="item"
                      :key="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.oaCode')" prop="OACode"
                  ><!--OA Code-->
                  <el-input
                    v-if="ruleForm.reserveType == 'ERP' || ruleForm.reserveType == 'ERP_ONE'"
                    :disabled="true"
                    v-model="ruleForm.OACode"
                    :fetch-suggestions="queryOAcodeAsync"
                    :placeholder="$t('pages.wording.placeholderInput')"
                  ></el-input>
                  <el-autocomplete
                    v-else
                    v-model="ruleForm.OACode"
                    :fetch-suggestions="queryOAcodeAsync"
                    :placeholder="$t('pages.wording.placeholderInput')"
                    @select="selectedOACode"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveArea')" prop="reserveArea"
                  ><!--抵達廠區-->
                  <el-input
                    v-model="ruleForm.reserveArea"
                    :placeholder="$t('pages.wording.placeholderSelect')"
                    :disabled="true"
                  ></el-input>
                  <!--<el-select v-model="ruleForm.reserveArea" :placeholder="$t('pages.wording.placeholderSelect')" @change="selectedReserveArea" value-key="area">
                    <el-option v-for="(item, index) in base.vendorAreaByOACode" :label="item.area" :value="item.area" :key="item.area" ></el-option>
                </el-select>-->
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.vendor')" prop="vendor"
                  ><!--公司名稱-->
                  <el-input
                    v-if="ruleForm.reserveType == 'ERP' || ruleForm.reserveType == 'ERP_ONE'"
                    :disabled="true"
                    v-model="ruleForm.vendor"
                    :placeholder="$t('pages.wording.placeholderInput')"
                  >
                  </el-input>
                  <el-input v-else v-model="ruleForm.vendor" :placeholder="$t('pages.wording.placeholderInput')">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveRegion')" prop="reserveRegion"
                  ><!--抵達地區-->
                  <el-input
                    v-model="ruleForm.reserveRegion"
                    :placeholder="$t('pages.wording.placeholderSelect')"
                    :disabled="true"
                  ></el-input>
                  <!--<el-select v-model="ruleForm.reserveRegion" :placeholder="$t('pages.wording.placeholderSelect')" @change="selectedReserveRegion">
                    <el-option v-for="(item, index) in base.regionBase" :label="item" :value="item">{{item}}</el-option>
                </el-select>-->
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveLocation')" prop="reserveLocation"
                  ><!--抵達地點-->
                  <el-select v-model="ruleForm.reserveLocation" :placeholder="$t('pages.wording.placeholderSelect')">
                    <el-option
                      v-for="item in base.locationByFactory"
                      :label="$store.getters.getSysCodeText('location', item)"
                      :value="item"
                      :key="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12" v-if="ruleForm.reserveType != 'ERP_ONE'">
                <el-form-item :label="$t('pages.wording.vendorContactName')" prop="vendorContactName"
                  ><!--廠商聯絡人-->
                  <el-select
                    v-model="ruleForm.vendorContactName"
                    :placeholder="$t('pages.wording.placeholderSelect')"
                    @change="selectedContact"
                  >
                    <el-option
                      v-for="item in base.contactData"
                      :label="item.name"
                      :value="item.name"
                      :key="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-else>
                <el-form-item :label="$t('pages.wording.vendorContactName')" prop="vendorContactName"
                  ><!--廠商聯絡人-->
                  <el-input v-model="ruleForm.vendorContactName" :placeholder="$t('pages.wording.placeholderSelect')">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.vendorContactNumber')" prop="vendorContactNumber"
                  ><!--廠商聯絡人電話-->
                  <el-input v-model="ruleForm.vendorContactNumber" :placeholder="$t('pages.wording.placeholderInput')">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.vendorContactMail')" prop="vendorContactMail"
                  ><!--廠商聯絡人Mail-->
                  <el-input v-model="ruleForm.vendorContactMail" :placeholder="$t('pages.wording.placeholderInput')">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveArriveDate')" prop="reserveArriveDate"
                  ><!--預約進廠日期-->
                  <el-date-picker
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    type="date"
                    :placeholder="$t('pages.wording.placeholderDate')"
                    @change="selectReserveDate"
                    v-model="ruleForm.reserveArriveDate"
                    style="width: 100%"
                    :picker-options="DatePickerOptions"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.enterReason')" prop="enterReason"
                  ><!--入廠事由-->
                  <el-select v-model="ruleForm.enterReason" :placeholder="$t('pages.wording.placeholderSelect')">
                    <el-option
                      v-for="item in enterReasonBase"
                      :label="item[$i18n.locale]"
                      :value="item.code"
                      :key="item.code"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveArriveTime')" prop="reserveArriveTime"
                  ><!--預約進廠時間-->
                  <el-time-select
                    :placeholder="$t('pages.wording.placeholderTime')"
                    v-model="ruleForm.reserveArriveTime"
                    style="width: 100%"
                    :picker-options="TimePickerOptions"
                  ></el-time-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!--boxContain c-form-->
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="soTable" v-if="isGenerateByERP">
          <template slot="title">
            <div class="titleBtn">
              <h3>{{ $t("pages.wording.releaseOrderInfo") }}</h3>
            </div>
          </template>
          <div>
            <ReserveSOTable v-if="isGenerateByERP" :reserveID="ruleForm.id" :reserveCarPlat="ruleForm.carlicensePlat" />
          </div>
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="carInfo" v-if="ruleForm.driverName !== null">
          <template slot="title">
            <!--driver-->
            <h3>{{ $t("pages.wording.carListInfo") }}</h3>
            <!--車輛資訊-->
          </template>
          <div class="boxContain c-form">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.driverName')" prop="driverName"
                  ><!--司機姓名-->
                  <el-input :disabled="true" v-model="ruleForm.driverName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.driverID')" prop="driverID"
                  ><!--司機ID-->
                  <el-input :disabled="true" v-model="ruleForm.driverID"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.carPlat')" prop="carlicensePlat"
                  ><!--車輛號牌-->
                  <el-input :disabled="true" v-model="ruleForm.carlicensePlat"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.driverPhone')" prop="driverPhone"
                  ><!--司機電話-->
                  <el-input :disabled="true" v-model="ruleForm.driverPhone"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.carType')" prop="carType"
                  ><!--車輛類型-->
                  <el-input :disabled="true" v-model="ruleForm.carType"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.carColor')" prop="carColor"
                  ><!--車輛顏色-->
                  <el-input :disabled="true" v-model="ruleForm.carColor"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div class="buttons c-form">
        <el-button class="blue-button" @click="back" type="primary">{{ $t("pages.button.back") }}</el-button
        ><!--取消-->
        <el-button
          v-if="ruleForm.reserveStatus === null || ruleForm.reserveStatus == 'temporary'"
          @click="SaveAndSubmit('save')"
          type="warning"
          >{{ $t("pages.button.temp") }}</el-button
        ><!--暫存-->
        <el-button class="blue-button button-right" type="primary" @click="SaveAndSubmit('submit')">{{
          $t("pages.button.send")
        }}</el-button
        ><!--送出-->
      </div>
    </el-form>
    <el-dialog :title="$t('pages.wording.vendorContactData')" :visible.sync="dialog.vendorContact" width="50%">
      <el-form>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.vendorContactListName')" prop="dialogVendorContactName"
              ><!--廠商聯絡人-->
              <el-input
                v-model="dialog.vendorContactName"
                :placeholder="$t('pages.wording.enterVendorContactName')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.vendorContactListNumber')" prop="dialogVendorContactPhone"
              ><!--聯絡人電話-->
              <el-input
                v-model="dialog.vendorContactPhone"
                :placeholder="$t('pages.wording.enterVendorContactNumber')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.vendorContactListMail')" prop="dialogVendorContactMail"
              ><!--聯絡人Mail-->
              <el-input
                v-model="dialog.vendorContactMail"
                :placeholder="$t('pages.wording.enterVendorContactMail')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.vendorContact = false">{{ $t("pages.button.cencel") }}</el-button>
        <el-button type="primary" @click="handleDialogVendorContact">{{ $t("pages.button.confirm") }}</el-button>
      </span>
    </el-dialog>
  </div>
  <!--pageMyReservationApply-->
</template>

<script>
import { store } from "@/store/store.js"
import { api } from "@/utils/api.js"
import { utils } from "@/utils/utils.js"
import ReserveSOTable from "@/components/Reserve/ReserveSOTable"
import { mapGetters } from "vuex"
import QueryEmpUser from "@/components/common/QueryEmpUser"

export default {
  name: "PageMyReservationTempForm",
  components: {
    ReserveSOTable,
    QueryEmpUser,
  },
  props: ["id", "parentName", "parent"],
  data() {
    return {
      reserveStatus: "temporary",
      DatePickerOptions: {
        disabledDate(time) {
          var date = new Date()
          date.setDate(date.getDate() - 1)

          return time.getTime() < date
        },
      },
      carringInfo: [],
      entourageInfo: [],
      dialog: {
        vendorContact: false,
        vendorContactMail: "",
        vendorContactPhone: "",
        vendorContactName: "",
      },
      ruleForm: {
        id: -1,
        reserveNo: "",
        createOacode: "",
        applyDate: "", //預約日期
        applyDatetime: "",
        applicatorName: "", //申請人
        applicatorNT: "",
        applicatorMail: "",
        deltaContactNT: "", //台達接洽人
        deltaContactNumber: "", //台達接洽人電話
        deltaContactMail: "", //台達接洽人Mail
        deltaContactDept: "",
        deltaContactName: "",
        deltaContactDisplayName: "",
        OACode: "",
        vendor: "", //廠商名稱
        enterReason: "", //進廠事由
        vendorContactName: "", //廠商接洽人
        vendorContactNumber: "", //廠商接洽人電話
        vendorContactMail: "", //廠商接洽人mail
        reserveArriveDate: "", //進廠日期
        reserveArriveTime: "", //進廠時間
        reserveArriveDatetime: "", //進廠時間
        reserveRegion: "",
        reserveFactory: "",
        reserveArea: "", //抵達廠別
        reserveLocation: "", //抵達地點
        reserveStatus: null,
        reserveType: "",
        //vendor
        tempCar: false,
        driverName: "",
        driverID: "",
        carPlat: "",
        driverNumber: "",
        tmpDriverName: "",
        tmpDriverID: "",
        tmpCarPlat: "",
        tmpDriverNumber: "",
        tmpCarType: "",
        tmpCarColor: "",
        carlicensePlat: "",
        driverPhone: "",
        carType: "",
        carColor: "",
        customerCode: "",
      },
      rules: {
        deltaContactNT: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "blur" }],
        deltaContactName: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "blur" }],
        deltaContactNumber: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "blur" }],
        deltaContactMail: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "blur" }],
        OACode: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "blur" }],
        vendor: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "blur" }],
        enterReason: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "change" }],
        vendorContactName: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "blur" }],
        vendorContactNumber: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "blur" }],
        vendorContactMail: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "blur" }],
        reserveArriveDate: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "blur" }],
        reserveArriveTime: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "blur" }],
        reserveRegion: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "change" }],
        reserveArea: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "change" }],
        reserveFactory: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "change" }],
        reserveLocation: [{ required: true, message: this.$t("pages.wording.requiredInput"), trigger: "change" }],
      },
      base: {
        regionBase: [],
        vendorAreaByOACode: [],
        vendorFactoryById: [],
        factoryBase: [],
        contactData: [],
        locationByFactory: [],
        driverNameData: [],
        carPlatData: [],
      },
      reserveData: [],
      alertMessage: {},
      activeShowBlock: ["basic", "reserve", "soTable", "carInfo"],
      tmpCarSwitch: 0,
      carDisable: false,
      isGenerateByERP: false,
      oaCodeIsChange: false,
      enterReasonBase: [],
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapGetters(["getUserProfile"]),
    init() {
      if (this.$props.id != 0 && this.$props.id != undefined) {
        this.updateInit(this.$props.id)
      } else if (this.$route.query.id != 0 && this.$route.query.id != undefined) {
        this.updateInit(this.$route.query.id)
      } else {
        this.newInit()
      }
    },
    newInit() {
      let userArea = this.getUserProfile().area
      const applyDatetime = new Date()
      this.ruleForm.applyDate = utils.getDateTime(applyDatetime)[0]
      this.ruleForm.applyDatetime = utils.convertDateToISOFormat(applyDatetime)

      this.ruleForm.applicatorNT = store.state.UserLoginData.userAD
      this.ruleForm.applicatorName = store.state.UserLoginData.userName
      this.ruleForm.applicatorMail = store.state.UserLoginData.userEmail
      this.ruleForm.deltaContactNT = store.state.UserLoginData.userAD
      this.ruleForm.deltaContactNumber = store.state.UserLoginData.userPhone
      this.ruleForm.deltaContactMail = store.state.UserLoginData.userEmail
      this.ruleForm.deltaContactName = store.state.UserLoginData.userName
      this.ruleForm.deltaContactDisplayName = store.state.UserLoginData.userName
      this.ruleForm.deltaContactDept = store.state.UserLoginData.userDept

      this.ruleForm.driverName = null
      this.getFactory("", userArea) //申請人可預約該權限廠區
    },
    updateInit(id) {
      this.getReserveInfo(id)
    },
    getVendorFactoryByOAcode(oacode) {
      oacode = this.ruleForm.reserveType == "ERP_ONE" ? "" : oacode
      let area = this.getUserProfile().area
      this.getFactory(oacode, area)
    },
    getFactory(oacode, area) {
      var parameter = {
        oacode: oacode,
        area: area,
      }
      this.$store.dispatch("getVendorFactoryByOAcode", parameter)
    },
    selectedReserveFactory(val) {
      this.getLocationByFactory(val)
      this.getRegionAreaByFactory(val)
      this.getVendorInfo(this.ruleForm.OACode)
    },
    getRegionAreaByFactory(factory) {
      this.ruleForm.reserveArea = ""
      this.ruleForm.reserveRegion = ""
      var paramter = {
        factory: factory,
      }
      this.$store.dispatch("getRegionAreaByFactory", { params: paramter })
    },
    getLocationByFactory(factory) {
      var parameter = {
        factory: factory,
      }
      this.$store.dispatch("getLocationByFactory", { params: parameter })
    },
    onChangeUser(code) {
      const parameter = {
        empCode: code,
      }
      this.$store.dispatch("getUserInfo", { params: parameter })
    },
    //**get Oacode
    queryOAcodeAsync(inputString, cb) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        var parameter = {
          oacode: inputString,
        }
        var cbData = []
        api
          .apiQueryOAcodeList({ params: parameter })
          .then((response) => {
            response.data.forEach((item) => {
              var tmp = {
                value: item,
              }
              cbData.push(tmp)
            })
            cb(cbData)
          })
          .catch((error) => {
            console.log(error)
          })
      }, 300)
    },
    selectedOACode(selectobj) {
      this.getVendorFactoryByOAcode(selectobj.value)
      //get vendorInfo and set vendor relative option
      this.oaCodeIsChange = true
      this.getVendorInfo(selectobj.value)
    },
    //**get contact
    selectedContact(val) {
      this.base.contactData.forEach((item, index) => {
        if (item.name == val) {
          this.ruleForm.vendorContactNumber = item.number //廠商接洽人電話
          this.ruleForm.vendorContactMail = item.mail //廠商接洽人mail
        }
      })
    },
    fillContactInfo(data) {
      if (this.ruleForm.reserveType == "ERP_ONE") return

      var check = false
      //var factory = this.ruleForm.reserveFactory != '' ?  this.ruleForm.reserveFactory : this.base.factoryBase[0]
      if (data.length != 0) {
        data.forEach((item, index) => {
          if (!check && item.job == "Salse") {
            check = true
            this.ruleForm.vendorContactName = item.name //廠商接洽人
            this.ruleForm.vendorContactNumber = item.number //廠商接洽人電話
            this.ruleForm.vendorContactMail = item.mail //廠商接洽人mail
          }
        })
        if (!check) {
          this.ruleForm.vendorContactName = data[0].name
          this.ruleForm.vendorContactNumber = data[0].number
          this.ruleForm.vendorContactMail = data[0].mail
        }
      }
    },
    //**get vendor
    getVendorInfo(oacode) {
      var parameter = {
        oacode: oacode,
        area: this.ruleForm.reserveArea,
      }
      if (this.ruleForm.reserveType != "ERP_ONE") {
        if (parameter.oacode == null || parameter.oacode == "" || parameter.area == null || parameter.area == "") {
          return
        }
        this.$store.dispatch("getVendorInfo", { params: parameter })
      }
    },
    resetOption(val) {
      switch (val) {
        case "oacode":
          //reset factory if there is no oacode in the selected factory
          if (this.base.vendorFactoryById !== null && this.base.vendorFactoryById.length > 0) {
            if (this.base.vendorFactoryById.includes(this.ruleForm.reserveFactory)) {
              return
            }
          }
          this.ruleForm.reserveRegion = ""
          this.ruleForm.reserveArea = ""
          this.ruleForm.reserveFactory = ""
          break
        case "region":
          this.ruleForm.reserveArea = ""
          this.base.vendorAreaByOACode = []
          break
        case "area":
          this.base.vendorFactoryById = []
          this.ruleForm.reserveFactory = ""
          break
        case "factory":
          //this.ruleForm.vendorContactName = ''; //廠商接洽人
          //this.ruleForm.vendorContactNumber = '';//廠商接洽人電話
          //this.ruleForm.vendorContactMail = '';//廠商接洽人mail
          this.ruleForm.reserveLocation = ""
          this.base.locationByFactory = []
          this.enterReasonBase = []
          break
      }
    },
    selectReserveDate() {
      this.ruleForm.reserveArriveTime = ""
    },
    /***************-FORM ACTIVE-***************/
    getReserveInfo(id) {
      this.$store.dispatch("getReserveInfo", { params: { id: id } })
    },
    getFormData(status) {
      let vm = this
      let id
      if (vm.$props.id == 0 || vm.$props.id == undefined) {
        if (vm.$route.query.id === 0 || vm.$route.query.id === undefined) {
          id = 0
        } else {
          id = parseInt(vm.$route.query.id)
        }
      } else {
        id = parseInt(vm.$props.id)
      }
      let datas = {
        id: id,
        reserveNo: vm.ruleForm.reserveNo,
        reserveStatus: status,
        applyDate: vm.ruleForm.applyDate,
        applyDatetime: vm.ruleForm.applyDatetime,
        applicatorName: vm.ruleForm.applicatorName,
        applicatorNT: vm.ruleForm.applicatorNT,
        applicatorMail: vm.ruleForm.applicatorMail,
        deltaContactNT: vm.ruleForm.deltaContactNT,
        deltaContactName: vm.ruleForm.deltaContactName,
        deltaContactNumber: vm.ruleForm.deltaContactNumber,
        deltaContactMail: vm.ruleForm.deltaContactMail,
        deltaContactDept: vm.ruleForm.deltaContactDept,
        OACode: vm.ruleForm.OACode,
        vendor: vm.ruleForm.vendor,
        enterReason: vm.ruleForm.enterReason,
        vendorContactName: vm.ruleForm.vendorContactName,
        vendorContactNumber: vm.ruleForm.vendorContactNumber,
        vendorContactMail: vm.ruleForm.vendorContactMail,
        reserveArriveDate: vm.ruleForm.reserveArriveDate,
        reserveArriveTime: vm.ruleForm.reserveArriveTime,
        reserveArriveDatetime: utils.getISOString(vm.ruleForm.reserveArriveDate + " " + vm.ruleForm.reserveArriveTime),
        reserveRegion: vm.ruleForm.reserveRegion,
        reserveArea: vm.ruleForm.reserveArea,
        reserveFactory: vm.ruleForm.reserveFactory,
        reserveLocation: vm.ruleForm.reserveLocation,
        reserveType: vm.ruleForm.reserveType,
        customerCode: vm.ruleForm.customerCode,
        groupCode: vm.ruleForm.groupCode,
        tempCar: vm.ruleForm.tempCar,
      }

      if (vm.ruleForm.tempCar) {
        datas.tmpDriverName = vm.ruleForm.tmpDriverName
        datas.tmpDriverID = vm.ruleForm.tmpDriverID
        datas.tmpDriverNumber = vm.ruleForm.tmpDriverNumber
        datas.tmpCarPlat = vm.ruleForm.tmpCarPlat
        datas.tmpCarType = vm.ruleForm.tmpCarType
        datas.tmpCarColor = vm.ruleForm.tmpCarColor
      } else {
        datas.driverName = vm.ruleForm.driverName
        datas.driverID = vm.ruleForm.driverID
        datas.driverNumber = vm.ruleForm.driverPhone
        datas.carPlat = vm.ruleForm.carlicensePlat
        datas.carType = vm.ruleForm.carType
        datas.carColor = vm.ruleForm.carColor
      }
      return datas
    },
    SaveAndSubmit(action) {
      let vm = this
      vm.$refs["ruleForm"].validate((valid) => {
        if (!valid) {
          console.log("some field is not allowed empty.")
          return false
        }
        let status = this.ruleForm.reserveStatus ?? this.reserveStatus
        let reserveData = vm.getFormData(status)
        let parameter = {
          reserveData: reserveData,
          logOperator: this.getUserProfile().userName,
          action: action,
        }
        utils.showLoading(vm)
        api
          .apiSaveAndSubmitReserveData(parameter)
          .then((response) => {
            utils.closeLoading(vm)
            if (response.data) {
              if (response.data.success) {
                let nextAction = function () {
                  var path = vm.$props.parent ? "/SearchReservation" : "/MyReservation"
                  vm.$router.push({ path: path })
                }
                utils.alertMessage(
                  vm,
                  0,
                  action == "submit" ? "successSubmit" : "successSave",
                  "information",
                  nextAction
                )
              } else {
                vm.$alert(vm.$t("pages.wording.occursWhenProcessReserveFlow"), "", {
                  confirmButtonText: vm.$t("pages.button.confirm"),
                })
              }
            }
          })
          .catch((error) => {
            console.log(error)
          })
      })
    },
    buildReserveInfo(data) {
      if (
        data.reserveStatus === "vendorComfirm" ||
        data.reserveStatus === "entering" ||
        data.reserveStatus === "temporary"
      ) {
        // do nothing...
      } else {
        this.$router.push({
          name: "PageMyReservationInfo",
          params: data,
        })
      }
      this.ruleForm.id = data.id
      this.ruleForm.reserveNo = data.reserveNo
      this.ruleForm.applicatorName = data.applicatorName
      this.ruleForm.applicatorNT = data.applicatorNT
      this.ruleForm.applicatorMail = data.applicatorMail
      this.ruleForm.deltaContactName = data.deltaContactName
      this.ruleForm.deltaContactDisplayName = data.deltaContactName
      this.ruleForm.deltaContactNT = data.deltaContactNT
      this.ruleForm.deltaContactDept = data.deltaContactDept
      this.ruleForm.deltaContactNumber = data.deltaContactNumber
      this.ruleForm.deltaContactMail = data.deltaContactMail
      this.ruleForm.OACode = data.OACode
      this.ruleForm.vendor = data.vendor
      this.ruleForm.enterReason = data.enterReason
      this.ruleForm.vendorContactName = data.vendorContactName
      this.ruleForm.vendorContactNumber = data.vendorContactNumber
      this.ruleForm.vendorContactMail = data.vendorContactMail
      this.ruleForm.reserveRegion = data.reserveRegion
      this.ruleForm.reserveArea = data.reserveArea
      this.ruleForm.reserveFactory = data.reserveFactory
      this.ruleForm.reserveLocation = data.reserveLocation
      this.ruleForm.reserveArriveDate = utils.getFormateDateTime("Date", data.reserveArriveDatetime)
      this.ruleForm.reserveArriveTime = utils.getFormateDateTime("Time", data.reserveArriveDatetime)
      this.ruleForm.reserveArriveDatetime = data.reserveArriveDatetime
      this.ruleForm.reserveStatus = data.reserveStatus
      this.ruleForm.applyDate = utils.getFormateDateTime("Date", data.applyDatetime)
      this.ruleForm.applyDatetime = utils.convertDateToISOFormat(utils.newDateFormat(data.applyDatetime))
      this.ruleForm.reserveType = data.reserveType
      this.ruleForm.customerCode = data.customerCode
      this.ruleForm.groupCode = data.groupCode

      this.ruleForm.tempCar = data.tempCar
      this.ruleForm.driverName = !data.tempCar ? data.driverName : data.tmpDriverName
      this.ruleForm.driverID = !data.tempCar ? data.driverID : data.tmpDriverID
      this.ruleForm.carlicensePlat = !data.tempCar ? data.carPlat : data.tmpCarPlat
      this.ruleForm.driverPhone = !data.tempCar ? data.driverNumber : data.tmpDriverNumber
      this.ruleForm.carType = !data.tempCar ? data.carType : data.tmpCarType
      this.ruleForm.carColor = !data.tempCar ? data.carColor : data.tmpCarColor
      //set select option

      //this.getRegion(data.reserveRegion);
      this.getVendorFactoryByOAcode(data.OACode)
      this.getVendorInfo(data.OACode)
      if (this.ruleForm.reserveType != "ERP_ONE" && this.ruleForm.reserveType != "ERP") {
        this.getEnterReasonBase()
        this.getLocationByFactory(data.reserveFactory)
      } else {
        //若無資料顯示預設
        if (this.ruleForm.enterReason == null || this.ruleForm.enterReason == "") {
          if (this.enterReasonBase.some((x) => x.code == "PickUp")) this.ruleForm.enterReason = "PickUp"
        }
        if (this.ruleForm.reserveLocation == null || this.ruleForm.reserveLocation == "") {
          if (this.base.locationByFactory.some((x) => x.code == "Pier")) this.ruleForm.reserveLocation = "Pier"
        }
      }

      this.isGenerateByERP = this.ruleForm.reserveType === "ERP" || this.ruleForm.reserveType === "ERP_ONE"
    },
    buildCarringInfo(data) {
      this.carringInfo = data
    },
    buildEntourageInfo(data) {
      this.entourageInfo = data
    },
    back() {
      let parent = this.$props.parentName
      let parameter = { back: true }

      if (parent == "searchReserve") {
        this.$router.push({
          name: "PageSearchReservation",
          params: parameter,
        })
      } else {
        this.$router.go(-1)
      }
    },
    handleDialogVendorContact() {
      this.ruleForm.vendorContactNumber = this.dialog.vendorContactPhone
      this.ruleForm.vendorContactName = this.dialog.vendorContactName
      this.ruleForm.vendorContactMail = this.dialog.vendorContactMail
      this.dialog.vendorContact = false
    },
    async getEnterReasonBase() {
      this.enterReasonBase = await utils.getCodeListWithCulture(
        this.ruleForm.reserveRegion,
        this.ruleForm.reserveArea,
        "enterReason"
      )
      //刷新選項後 不在選項內的要消除
      if (!this.enterReasonBase.some((x) => x.code == this.ruleForm.enterReason)) {
        this.ruleForm.enterReason = ""
      }
    },
  },
  computed: {
    enableEditVendorForm: function () {
      return !(this.ruleForm.reserveStatus === "vendorComfirm" || this.ruleForm.reserveStatus === "entering")
    },
    TimePickerOptions: function () {
      if (this.ruleForm.reserveArriveDate == "") return { start: "00:00", step: "00:15", end: "23:45" }

      var now = new Date()
      var reserveDate = utils.getDateTime(new Date(this.ruleForm.reserveArriveDate))
      var nowDate = utils.getDateTime(now)
      var reserveStr = reserveDate[0]
      var nowStr = nowDate[0]
      var hr = now.getHours()
      var min

      if (reserveStr == nowStr) {
        if (now.getMinutes() / 15 > 3) {
          hr += 1
          min = 0
        } else {
          min = Math.ceil(now.getMinutes() / 15) * 15
        }
      } else {
        hr = 0
        min = 0
      }

      var nowTime = utils.pad(hr) + ":" + utils.pad(min)
      var options = {
        start: nowTime,
        step: "00:15",
        end: "23:45",
      }

      return options
    },
  },
  watch: {
    "$store.getters.regionBase": function (val) {
      this.base.regionBase = val
    },
    "$store.getters.areaBase": function (val) {
      var AreaArray = []
      val.forEach(function (e, index) {
        var Area = new Object()
        Area.area = e
        AreaArray.push(Area)
      })
      this.base.vendorAreaByOACode = AreaArray
    },
    "$store.getters.factoryBase": function (val) {
      this.base.vendorFactoryById = val
    },
    "$store.getters.vendorAreaByOACode": function (val) {
      this.base.vendorAreaByOACode = val
    },
    "$store.getters.userInfo": function (val) {
      this.ruleForm.deltaContactMail = val.email
      this.ruleForm.deltaContactNumber = val.extNo
      this.ruleForm.deltaContactDept = val.deptCodeLname
      this.ruleForm.deltaContactName = val.empName
      this.ruleForm.deltaContactNT = val.adAccount
    },
    "$store.getters.alertMessage": function (val) {
      var code = val.code
      var message = val.message
      var cb = val.cb
      var title = "information"
      if (val.result != undefined) {
        this.alertMessage.result = val.result
      }
      utils.alertMessage(this, code, message, title, cb)
    },
    "$store.getters.vendorDataInfo": function (data) {
      this.ruleForm.vendor = data.vendor
    },
    "$store.getters.contactDataInfo": function (data) {
      this.base.contactData = data

      //for init reserve
      if (this.ruleForm.vendorContactName === "" || this.oaCodeIsChange === true) {
        this.fillContactInfo(data)
        this.oaCodeIsChange = false
      }
    },
    "$store.getters.reserveInfo": function (datas) {
      var reserveData = datas.result
      this.buildReserveInfo(reserveData.reserveData)
      this.buildCarringInfo(reserveData.carringData)
      this.buildEntourageInfo(reserveData.entourageData)
    },
    "$store.getters.locationByFactory": function (data) {
      this.base.locationByFactory = data
    },
    "$store.getters.vendorFactoryByOacode": function (data) {
      this.base.vendorFactoryById = data
      this.resetOption("oacode")
    },
    "$store.getters.regionAreaFactory": function (data) {
      this.ruleForm.reserveArea = data.area
      this.ruleForm.reserveRegion = data.region
      this.getVendorInfo(this.ruleForm.OACode)
      this.getEnterReasonBase()
    },
    "$store.getters.createOacode": function (data) {
      this.ruleForm.createOacode = data
    },
  },
}
</script>

<style scoped>
.titleBtn .blue-button {
  margin-left: 20px;
}
.titleBtn h3 {
  display: inline-block;
}
</style>
